module.exports = __webpack_public_path__ + "static/media/steve.1fa81202.jpg";